var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-collapse",
        { attrs: { accordion: "accordion" } },
        [
          _c(
            "el-collapse-item",
            { attrs: { title: _vm.titulo, name: "1" } },
            [
              _c(
                "el-table",
                {
                  staticStyle: { width: "100%" },
                  attrs: {
                    data: _vm.atividades,
                    "header-row-style": _vm.headerRowStyle,
                    border: "border"
                  }
                },
                [
                  _c("el-table-column", {
                    attrs: { formatter: _vm.formataTipo, label: "tipo" }
                  }),
                  _c("el-table-column", {
                    attrs: { formatter: _vm.getArea, label: _vm.getLabel() }
                  }),
                  _vm.tipoAtividade === "OUTRAS_ATIVIDADES"
                    ? _c("el-table-column", {
                        attrs: { prop: "observacoes", label: "Observações" }
                      })
                    : _vm._e()
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-aa5c97d0", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-aa5c97d0","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/screens/central/cadastros/para/retificacao/components/resumos/AppCollapse.vue
// module id = null
// module chunks = 